/**
 * The global state selectors
 */

import { createSelector } from 'reselect';
import { initialState } from './reducer';

const makeSelectGlobalState = state => state.global || initialState;

const makeSelectCurrentPage = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.currentPage);

const makeSelectConfig = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.config);

const makeSelectLoading = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.user.loading);

const makeSelectError = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.user.error);

const makeSelectGreetingMessageAction = () =>
    createSelector(makeSelectGlobalState, globalState => globalState.greetingMessageAction);

const makeSelectCurrentUser = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.user.data);

const makeSelectTriggerForms = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.externalTriggers.forms);

const makeSelectMappedFormFields = () =>
    createSelector(makeSelectGlobalState, globalState => globalState.externalTriggers.formFields);

const makeSelectTriggerElements = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.externalTriggers.elements);

const makeSelectWidgetSound = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.widgetSound);

const makeSelectGifs = () =>
    createSelector(makeSelectGlobalState, globalState => globalState.gifs);

const makeSelectIsShowWidget = () =>
  createSelector(makeSelectGlobalState, globalState => {
    const currentUser = globalState.user.data;
    const isShowWidget =
      currentUser &&
      currentUser.settings &&
      currentUser.settings.widget &&
      currentUser.settings.widget.show;

    return isShowWidget;
  });

const makeSelectCurrentUserChannelId = () =>
  createSelector(
    makeSelectGlobalState,
    globalState => globalState.user.data && globalState.user.data.channelId
  );

const makeSelectPopupMessage = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.popupMessage);

const makeSelectCurrentUserSettings = () =>
  createSelector(
    makeSelectGlobalState,
    globalState => globalState.user.data && globalState.user.data.settings
  );

const makeSelectHideCompanyDetailsInWidget = () =>
    createSelector(
        makeSelectGlobalState,
        globalState => globalState.config && globalState.config.hideCompanyDetailsInWidget
    );

const makeSelectCurrentUserSettingColor = () =>
  createSelector(
    makeSelectGlobalState,
    globalState =>
      globalState.user.data &&
      globalState.user.data.settings &&
      globalState.user.data.settings.color
  );

const makeSelectLanguage = () =>
    createSelector(
        makeSelectGlobalState,
        globalState => globalState.language
    );

const makeSelectCurrentUserSettingBot = () =>
  createSelector(
    makeSelectGlobalState,
    globalState =>
      globalState.user.data && globalState.user.data.settings && globalState.user.data.settings.bot
  );

const makeSelectCurrentUserConversations = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.conversations.data);

const makeSelectCurrentUserConversation = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.conversation.data);

const makeSelectUserAttachments = () =>
    createSelector(makeSelectGlobalState, globalState => globalState.userAttachments);

const makeSelectIsTyping = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.conversation.isTyping);

const makeSelectShowTypingIndicator = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.showTypingIndicator);

const makeSelectConversationMessages = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.conversation.messages);

const makeSelectIsLoadingCurrentUserConversations = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.conversations.loading);

const makeSelectDelayFlag = () =>
    createSelector(makeSelectGlobalState, globalState => globalState.delayFlag);

const makeSelectConversationLoading = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.conversation.loading);
const makeSelectCurrentChannel = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.currentChannel);

const makeSelectCurrentAgent = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.agent);

const makeSelectSubscriptionChannel = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.user.data.subscriptionChannel);

const makeSelectNetworkStatus = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.networkStatus);

const makeSelectSendingMessages = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.conversation.sendingMessages);

const makeSelectIsPusherConnected = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.isPusherConnected);

const makeSelectParentFrameSize = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.frameSize);

const makeSelectHideRestartButton = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.hideRestartButton);

const makeSelectIsMessageUnread = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.isMessageUnread);

const makeSelectInitiateSocketConnection = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.InitiateSocketConnection);

const makeSelectPopupToNotificationMessage = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.popupToNotificationMessage);

const makeSelectServerMessagesQueue = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.serverMessagesQueue);

const makeSelectDisabledCovnersation = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.disabledConversation);

const makeSelectCustomCookies = () =>
    createSelector(makeSelectGlobalState, globalState => globalState.customCookies);

const makeSelectNotificationRead = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.notificationRead);

const makeSelectAgentNewMessageList = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.agentNewMessageList);

const makeSelectWidgetVisibility = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.widgetVisibility);

const makeSelectTextAreaNumberOfLines = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.textAreaNumberOfLines);
const makeSelectClearBotActivePath = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.clearBotActivePath);

const makeSelectNetworkDelay = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.networkDelay);

const makeSelectIframePage = () =>
  createSelector(makeSelectGlobalState, globalState => globalState.iframePage);

export {
  makeSelectGlobalState,
  makeSelectCurrentPage,
  makeSelectConfig,
  makeSelectCurrentUser,
  makeSelectLoading,
  makeSelectError,
  makeSelectIsShowWidget,
  makeSelectCurrentUserChannelId,
  makeSelectPopupMessage,
  makeSelectCurrentUserSettings,
  makeSelectHideCompanyDetailsInWidget,
  makeSelectCurrentUserSettingColor,
  makeSelectCurrentUserSettingBot,
  makeSelectCurrentUserConversations,
  makeSelectCurrentUserConversation,
  makeSelectConversationMessages,
  makeSelectIsLoadingCurrentUserConversations,
  makeSelectConversationLoading,
  makeSelectCurrentChannel,
  makeSelectSubscriptionChannel,
  makeSelectNetworkStatus,
  makeSelectSendingMessages,
  makeSelectParentFrameSize,
  makeSelectPopupToNotificationMessage,
  makeSelectCurrentAgent,
  makeSelectTriggerForms,
  makeSelectTriggerElements,
  makeSelectMappedFormFields,
  makeSelectIsMessageUnread,
  makeSelectDisabledCovnersation,
  makeSelectNotificationRead,
  makeSelectAgentNewMessageList,
  makeSelectWidgetVisibility,
  makeSelectLanguage,
  makeSelectWidgetSound,
  makeSelectTextAreaNumberOfLines,
  makeSelectClearBotActivePath,
  makeSelectIsTyping,
  makeSelectShowTypingIndicator,
  makeSelectNetworkDelay,
  makeSelectGreetingMessageAction,
  makeSelectIframePage,
  makeSelectIsPusherConnected,
  makeSelectInitiateSocketConnection,
  makeSelectDelayFlag,
  makeSelectServerMessagesQueue,
  makeSelectHideRestartButton,
  makeSelectUserAttachments,
  makeSelectCustomCookies,
  makeSelectGifs,
};
